import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/store';
import getCookie from '../../../helper/getCookie';
import getDecryptData from '../../../helper/getDecryptData';
import eraseCookie from '../../../helper/eraseCookie';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const Account = () => {
  const decryptdatajson = getDecryptData();
  const isLoginFromLocalStorage = getCookie('token') ? true : false;
  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  const dispatch = useDispatch();

  const handleLogout = () => {
    try {
      dispatch(authActions.logout());
      toast.success("Logout Successfully");
      eraseCookie('token')
      setIsLogin(false);
    } catch (error) {
      console.log(error);
    }
  };

  // Card component for reuse
  const AccountCard = ({ icon, title, desc, to, onClick }) => (
    <div className="col-lg-3 col-md-6 mb-4">
      <Link
        to={to || '#'}
        onClick={onClick}
        className="text-decoration-none text-dark"
      >
        <div className="card shadow-sm border-0 h-100 hover-scale">
          <div className="card-body d-flex flex-column align-items-center text-center py-4">
            <div className="icon-circle bg-primary text-white mb-3" style={{
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '24px'
            }}>
              <i className={icon}></i>
            </div>
            <h6 className="card-title">{title}</h6>
            <p className="card-text text-muted">{desc}</p>
          </div>
        </div>
      </Link>
    </div>
  );

  return (
    <>
      <Header />
      <main className="page-content bg-light py-5">
        <div className="container">
          <h2 className="mb-4 text-center">My Account</h2>

          {isLogin ? (
            <div className="row g-4">

              {/* Orders Section */}
              {decryptdatajson && decryptdatajson.type !== 1 ? (
                <AccountCard
                  icon="fas fa-box-open"
                  title="My Orders"
                  desc="Manage all my orders"
                  to="/account/all-order"
                />
              ) : (
                <>
                  <AccountCard icon="fas fa-box-open" title="All Orders" desc="View all orders" to="/all-order" />
                  <AccountCard icon="fas fa-hourglass-half" title="Pending Orders" desc="View pending orders" to="/pending-order" />
                  <AccountCard icon="fas fa-check-circle" title="Complete Orders" desc="View completed orders" to="/complete-order" />
                  <AccountCard icon="fas fa-times-circle" title="Cancelled Orders" desc="View cancelled orders" to="/cancel-order" />
                </>
              )}

              {/* Account Section */}
              <AccountCard icon="far fa-address-book" title="My Profile" desc="Update your profile" to="/account/profile" />
              <AccountCard icon="far fa-user" title="Change Password" desc="Update your password" to="/account/password" />
              <AccountCard icon="fas fa-headset" title="Help & Support" desc="Get help and support" to="/account/support" />
              <AccountCard icon="fas fa-sign-out-alt" title="Logout" desc="Logout your account" onClick={handleLogout} />

            </div>
          ) : (
            <div className="row g-4 justify-content-center">
              <AccountCard icon="fas fa-headset" title="Help & Support" desc="Get help and support" to="/account/support" />
              <AccountCard icon="fas fa-sign-in-alt" title="Login" desc="Login to your account" to="/login" />
            </div>
          )}
        </div>
      </main>
      <Footer />

      {/* Custom Hover Effect */}
      <style>
        {`
          .hover-scale:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 20px rgba(0,0,0,0.15);
            transition: all 0.3s ease;
          }
          .icon-circle i {
            font-size: 28px;
          }
        `}
      </style>
    </>
  )
}

export default Account;
